import { render, staticRenderFns } from "./MultOfferItem.vue?vue&type=template&id=151857e4&scoped=true&"
import script from "./MultOfferItem.vue?vue&type=script&lang=ts&"
export * from "./MultOfferItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151857e4",
  null
  
)

export default component.exports